import { render, staticRenderFns } from "./onlineExpoBanner2.vue?vue&type=template&id=16647fa8&"
import script from "./onlineExpoBanner2.vue?vue&type=script&lang=js&"
export * from "./onlineExpoBanner2.vue?vue&type=script&lang=js&"
import style0 from "./onlineExpoBanner2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports